var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGrammerly = function SvgIconGrammerly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    d: "M13.24 3.807a6.683 6.683 0 0 0-9.447 0 6.684 6.684 0 0 0 .134 9.58c2.533 2.393 6.64 2.393 9.173 0a6.68 6.68 0 0 0 .14-9.58M11.42 11.6c-.8.76-1.853 1.14-2.907 1.14a4.2 4.2 0 0 1-2.906-1.14.503.503 0 0 1-.02-.707.503.503 0 0 1 .706-.02c1.22 1.154 3.214 1.16 4.44 0 .2-.186.52-.18.707.02.193.2.18.514-.02.707"
  })));
};
export default SvgIconGrammerly;